import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrcamentosEPacotesDetalharRoutingModule } from './orcamentos-e-pacotes-detalhar-routing.module';
import { OrcamentosEPacotesDetalharComponent } from './orcamentos-e-pacotes-detalhar.component';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';


@NgModule({
  declarations: [
    OrcamentosEPacotesDetalharComponent
  ],
  imports: [
    CommonModule,
    OrcamentosEPacotesDetalharRoutingModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DividerModule,
    ProgressSpinnerModule,
    MessagesModule
    
  ]
})
export class OrcamentosEPacotesDetalharModule { }
